import * as Yup from 'yup';

export interface IPaymentListItem {
  calculationId: string;
  calculationPaymentId: string;
  dateOfAuthorization: string | null;
  dateOfPayment: string | null;
  guestId: string | null;
  instalment: number;
  instalmentAmount: number;
  instalmentCurrencyId: string;
  methodOfPaymentId: string;
  note: string | null;
  noteTranslated: string | null;
  paymentCurrencyIso: string | null;
  paymentCurrencySymbol: string | null;
  paymentModelId: string | null;
  services: string | null;
  status: number | null;
  isDeleted: boolean;
  totalAmount: number;
  totalAmountCurrencyISO: string | null;
  totalAmountCurrencySymbol: string | null;
  transfer: string | null;
  paymentType: string | null;
  paidAmount: number;
  b2BPaidAmount: number;
  b2BPaidAmountCurrencyISO: string | null;
  b2BPaidAmountCurrencySymbol: string | null;
  b2BUnpaidAmount: number;
  b2BUnpaidAmountCurrencyISO: string | null;
  b2BUnpaidAmountCurrencySymbol: string | null;
  invoice?: string | null;
  invoiceAmount?: string | null;
  invoiceCurrency?: string | null;
}

export const PaymentListItemSchema = Yup.object().shape({
  installment: Yup.number().required('Required'),
  dateOfAuthorization: Yup.string().required('Required'),
  instalmentAmount: Yup.string().required('Required'),
  methodOfPaymentId: Yup.number().nullable(),
  dateOfPayment: Yup.string().nullable(),
  paidAmount: Yup.number().nullable(),
});
